import React, { useCallback, useState } from 'react';
import { Config } from '@leverege/plugin';
import { Attributes, EditorUtil } from '@leverege/ui-attributes';
import { CompositeTextInput } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { Toolbar } from '@leverege/ui-plugin';
import LoadingView from "../../../views/LoadingView.js";
import { removeNonVINCharacters } from "./VINUtils.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.imagine.forms.attributeValueEditorOverrides.VINEditor');
const opts = {
  table: {
    isRenderer: false,
    embed: true
  },
  detail: {
    isRenderer: false,
    embed: true
  }
};
const client = 'VINEditor';
function VINEditor(props) {
  const {
    attribute,
    value,
    onChange: pOnChange,
    usage,
    api,
    eventData
  } = props;
  const [hasVinApi, setHasVinApi] = useState(true);
  const decodeVin = useCallback(async vin => {
    const meta = attribute?.source?.attribute?.metadata?.vinEditor;
    if (hasVinApi && meta?.fieldUpdateMap) {
      const projectId = api.options.projectId;
      const close = LoadingView.showDialog(t('loading'));
      try {
        const res = await api.project(projectId).srv(`vin/${vin}`).get();
        return res.result;
      } catch (err) {
        console.error(err);
        if (err.status === 404) {
          setHasVinApi(false);
        }
        return null;
      } finally {
        close();
      }
    }
    return null;
  }, [api, hasVinApi, attribute]);
  const onChange = useCallback(async evt => {
    const val = removeNonVINCharacters(evt.value);
    const data = await decodeVin(val);
    if (!data) {
      pOnChange({
        data: evt.data,
        value: val
      });
    } else {
      const fieldUpdateMap = attribute.source.attribute.metadata.vinEditor.fieldUpdateMap;
      const update = {
        data: {
          [evt.data]: evt.data
        },
        value: {
          [evt.data]: val
        }
      };
      Object.entries(data).forEach(([key, value]) => {
        if (fieldUpdateMap[key]) {
          update.data[fieldUpdateMap[key]] = fieldUpdateMap[key];
          update.value[fieldUpdateMap[key]] = key === 'year' ? parseInt(value) : value;
        }
      });
      pOnChange(update);
    }
  }, [pOnChange, decodeVin, attribute]);
  const onSearchChange = useCallback(evt => {
    onChange({
      data: eventData,
      value: evt.value
    });
  }, [onChange, eventData]);
  const getContext = useCallback(() => {
    return {
      attribute,
      isScannable: attribute.source?.attribute?.getTagStartingWith('scannable:', true),
      clientProps: {
        objectType: attribute.objectType
      },
      onSearchChange
    };
  }, [attribute, onSearchChange]);
  return /*#__PURE__*/_jsx(CompositeTextInput, {
    variant: EditorUtil.getVariant(usage, 'string', 'editor'),
    value: value,
    eventData: eventData,
    onChange: onChange,
    post: /*#__PURE__*/_jsx(Toolbar, {
      variant: "actionBar",
      prefer: "icon",
      context: getContext(),
      matchContext: {
        client,
        objectType: attribute.objectType
      }
    })
  });
}
export default {
  createFor(name, objectType, {
    molten
  }) {
    const attr = Attributes.getAttribute(name, objectType);
    const meta = attr?.source?.attribute?.metadata;
    if (meta.vinEditor) {
      molten.addPlugin('AttributeValueEditor', {
        name,
        objectType,
        getOptions(usage) {
          return Config.get('VINEditor', usage, opts[usage]);
        },
        create(opts) {
          return /*#__PURE__*/_jsx(VINEditor, {
            ...opts,
            api: molten.get('api')
          });
        }
      });
    }
  }
};